
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/instagram-shadowban-checker",
      function () {
        return require("private-next-pages/instagram-shadowban-checker/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/instagram-shadowban-checker"])
      });
    }
  